import {
  BanksApiBanksRequest,
  BankWrapperList,
  CACHE_KEYS,
} from "@bn/api/apiv1";
import { useAuthQuery, UseQueryExtendedOptions } from "@bn/api";
import { getBanksBySearch } from "../methods/banks";

export const useBanksSearch = (
  params: BanksApiBanksRequest,
  options?: UseQueryExtendedOptions<
    BankWrapperList,
    AxiosApiError,
    BankWrapperList
  >
) => {
  return useAuthQuery(
    [CACHE_KEYS.BANKS, params],
    ({ token }) => getBanksBySearch(token, params),
    options
  );
};
